import styled from "styled-components";

export const SocialShareWrapper = styled.div`
    margin: 0 0 0 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
`;

export const SocialShareButton = styled.button`
    background-color: transparent;
    border: none;
    margin: 0;
    padding: 0;
    outline: none;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
`;